import(/* webpackMode: "eager", webpackExports: ["InAppBannerContainer"] */ "/vercel/path0/apps/web/components/common/in-app-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/vercel/path0/apps/web/components/common/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TheHeader"] */ "/vercel/path0/apps/web/components/common/the-header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.4.1_@opentelemetry+api@1.9.1_@playwright+test@1.62.1_@types+node@24.0.8_babel-plugin-_xhv6slofrqmj5g6qy5kbnyd6tu/node_modules/next/dist/client/app-dir/link.js");
